import script from "./BalLoadingBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalLoadingBlock.vue?vue&type=script&lang=ts&setup=true"

import "./BalLoadingBlock.vue?vue&type=style&index=0&id=66b71f88&lang=css"

const __exports__ = script;

export default __exports__